module.exports = __webpack_public_path__ + "images/16ba8f468e034a23ba6be5261278ef56.png";